module.exports = __webpack_public_path__ + "img/signs7.ae0a595e.jpg";